(function() { window.GUID_22c39672_2357_409c_b102_2fe17593334c = { getGuid: function() { return "22c39672-2357-409c-b102-2fe17593334c"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var VideoPlayerInternals;
        (function (VideoPlayerInternals) {
            class BaseInternal {
                constructor(player) {
                    this.player = player;
                    this.eventRaiser = player.registerBaseInternal(this);
                    this.elements = player.Elements;
                }
                Dispose() {
                    this.OnDispose();
                }
                zeroPad(num, places) {
                    var zero = places - num.toString().length + 1;
                    return Array(+(zero > 0 && zero)).join("0") + num;
                }
                displaySeconds(seconds) {
                    var ret = "";
                    var totalSeconds = seconds;
                    var str = (n) => {
                        return this.zeroPad(n, 2);
                    };
                    if (this.elements.timeDisplay.totalIsMoreThanOneHour) {
                        var _hours = Math.floor(totalSeconds / 3600);
                        totalSeconds %= 3600;
                        ret += str(_hours) + ":";
                    }
                    var _minutes = Math.floor(totalSeconds / 60);
                    var _seconds = Math.floor(totalSeconds % 60);
                    ret += str(_minutes) + ":" + str(_seconds);
                    return ret;
                }
                event(element) {
                    if (CS.Is(element, HTMLElement) || CS.Is(element, Document) || CS.Is(element, Window))
                        return this.player.event(element);
                    return this.player.event(element);
                }
            }
            VideoPlayerInternals.BaseInternal = BaseInternal;
        })(VideoPlayerInternals = Controls.VideoPlayerInternals || (Controls.VideoPlayerInternals = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=VideoPlayer.BaseInternals.pre.js.map
